var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUserSecession(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 13C12.21 13 14 11.21 14 9C14 6.79 12.21 5 10 5C7.79 5 6 6.79 6 9C6 11.21 7.79 13 10 13ZM10 7C11.1 7 12 7.9 12 9C12 10.1 11.1 11 10 11C8.9 11 8 10.1 8 9C8 7.9 8.9 7 10 7Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99717 14C6.47863 14 3.55984 16.54 3.01007 19.86C2.91011 20.46 3.39991 21 4.01965 21C4.51945 21 4.92928 20.64 5.01924 20.15C5.42907 17.79 7.49821 16 9.99717 16C12.4961 16 14.5753 17.79 14.9751 20.15C15.0551 20.64 15.4749 21 15.9747 21C16.5844 21 17.0842 20.46 16.9843 19.86C16.4345 16.53 13.5157 14 9.99717 14Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6334 3.56572L16.2322 6.96691C15.9198 7.27933 15.9198 7.78586 16.2322 8.09828C16.5446 8.4107 17.0511 8.4107 17.3636 8.09828L20.7647 4.69709C21.0772 4.38468 21.0772 3.87814 20.7647 3.56572C20.4523 3.25331 19.9458 3.2533 19.6334 3.56572Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3636 3.57274C17.0511 3.26032 16.5446 3.26032 16.2322 3.57274C15.9198 3.88516 15.9198 4.39169 16.2322 4.70411L19.6334 8.1053C19.9458 8.41772 20.4523 8.41772 20.7647 8.1053C21.0772 7.79288 21.0772 7.28635 20.7647 6.97393L17.3636 3.57274Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserSecession);
export default __webpack_public_path__ + "static/media/icon-user-secession.c90b7c27b1ed774c1c5025ee58a862cd.svg";
export { ForwardRef as ReactComponent };